(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-categories"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lexi-brand-categories')) {
    customElements.define('lexi-brand-categories', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const options = {signal: this.controller.signal};
        this.track = this.querySelector('.brand-categories__track');
        if (!this.track) return;
        this.items = Array.from(this.track.children);
        this.controls = this.querySelector('.brand-categories__controls');
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.index = 0;
        this.visible = false;
        this.hovered = false;
        this.focused = false;
        this.dragging = false;
        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.sync());
        }, {...options, passive: true});
        this.addEventListener('click', event => {
          const button = event.target.closest('button');
          if (!button || !this.contains(button)) return;
          if (button.hasAttribute('data-next')) this.advance(1);
          if (button.hasAttribute('data-previous')) this.advance(-1);
          this.schedule();
        }, options);
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            const rtl = getComputedStyle(this).direction === 'rtl';
            this.advance((event.key === 'ArrowRight') !== rtl ? 1 : -1);
          }
          this.schedule();
        }, options);
        this.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { this.hovered = true; this.schedule(); } }, options);
        this.addEventListener('pointerleave', () => { this.hovered = false; this.schedule(); }, options);
        this.track.addEventListener('pointerdown', () => { this.dragging = true; this.schedule(); }, options);
        window.addEventListener('pointerup', () => { this.dragging = false; this.schedule(); }, options);
        this.track.addEventListener('pointercancel', () => { this.dragging = false; this.schedule(); }, options);
        this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, options);
        this.addEventListener('focusout', event => { if (!this.contains(event.relatedTarget)) { this.focused = false; this.schedule(); } }, options);
        document.addEventListener('visibilitychange', () => this.schedule(), options);
        this.motion.addEventListener('change', () => this.schedule(), options);
        this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.schedule(); }, {threshold: .25});
        this.observer.observe(this);
        this.resizeObserver = new ResizeObserver(() => { this.sync(); this.schedule(); });
        this.resizeObserver.observe(this.track);
        this.sync();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.resizeObserver?.disconnect();
        clearTimeout(this.timer);
        cancelAnimationFrame(this.frame);
      }
      sync() {
        this.overflow = this.track.scrollWidth > this.track.clientWidth + 2;
        if (this.controls) this.controls.hidden = !this.overflow;
        this.track.tabIndex = this.overflow ? 0 : -1;
        const bounds = this.track.getBoundingClientRect();
        const rtl = getComputedStyle(this).direction === 'rtl';
        let closest = Infinity;
        this.items.forEach((item, index) => {
          const rect = item.getBoundingClientRect();
          const distance = Math.abs(rtl ? rect.right - bounds.right : rect.left - bounds.left);
          if (distance < closest) { closest = distance; this.index = index; }
        });
      }
      advance(direction) {
        if (!this.overflow || !this.items.length) return;
        const rtl = getComputedStyle(this).direction === 'rtl';
        const offset = Math.abs(this.track.scrollLeft);
        const end = this.track.scrollWidth - this.track.clientWidth;
        if (direction > 0 && offset >= end - 2) {
          this.track.scrollTo({left: 0, behavior: this.motion.matches ? 'instant' : 'smooth'});
        } else if (direction < 0 && offset <= 2) {
          this.track.scrollTo({left: rtl ? -end : end, behavior: this.motion.matches ? 'instant' : 'smooth'});
        } else {
          const step = this.items[0].getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap);
          this.track.scrollBy({left: step * direction * (rtl ? -1 : 1), behavior: this.motion.matches ? 'instant' : 'smooth'});
        }
      }
      schedule() {
        clearTimeout(this.timer);
        if (this.dataset.autoplay !== 'true' || !this.overflow || this.motion.matches || !this.visible || this.hovered || this.focused || this.dragging || document.hidden) return;
        this.timer = setTimeout(() => { this.advance(1); this.schedule(); }, Number(this.dataset.interval) || 4000);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lexi-reviews-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lexi-review-marquee')) {
    class LexiReviewMarquee extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        this.states = [];
        this.paused = false;
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        const options = { signal: this.abort.signal };
        this.button = this.querySelector('[data-review-pause]');
        this.button?.addEventListener('click', () => {
          this.paused = !this.paused;
          this.button.textContent = this.paused ? this.button.dataset.resume : this.button.dataset.pause;
          this.button.setAttribute('aria-pressed', String(this.paused));
          this.sync();
        }, options);
        this.reduced.addEventListener('change', () => this.setup(), options);
        document.addEventListener('visibilitychange', () => this.sync(), options);
        this.addEventListener('shopify:block:select', event => {
          const state = this.states.find(s => s.row.contains(event.target));
          if (!state) return;
          const card = event.target.closest('[data-review-block]');
          if (!card) return;
          this.paused = true;
          this.button?.setAttribute('aria-pressed','true');
          if (this.button) this.button.textContent = this.button.dataset.resume;
          this.setOffset(state, -card.offsetLeft);
        }, options);
        this.setup();
        this.inView = true;
        this.visibilityObserver = new IntersectionObserver(([entry]) => { this.inView = entry.isIntersecting; this.sync(); });
        this.visibilityObserver.observe(this);
        this.resize = new ResizeObserver(() => {
          const width = this.clientWidth;
          if (this.lastWidth !== width) { this.lastWidth = width; this.setup(); }
        });
        this.lastWidth = this.clientWidth;
        this.resize.observe(this);
        document.fonts?.ready.then(() => { if (this.isConnected) this.setup(); });
      }
      disconnectedCallback() {
        this.abort?.abort(); this.resize?.disconnect(); this.visibilityObserver?.disconnect(); this.querySelectorAll('[data-review-row]').forEach(row => delete row.dataset.bound);
        this.states?.forEach(s => s.animation?.cancel());
      }
      setup() {
        this.states?.forEach(s => s.animation?.cancel());
        this.states = [];
        this.querySelectorAll('[data-review-clone]').forEach(e => e.remove());
        const autoplay = this.dataset.autoplay === 'true' && !this.reduced.matches;
        this.button?.toggleAttribute('hidden', !autoplay);
        this.querySelectorAll('[data-review-row]').forEach(row => {
          const track = row.querySelector('.lexi-reviews__track');
          const group = row.querySelector('[data-review-original]');
          track.style.transform = '';
          row.removeAttribute('data-enhanced'); row.scrollLeft = 0;
          const distance = group.getBoundingClientRect().width;
          if (!autoplay || !distance) return;
          const copies = Math.ceil(row.clientWidth / distance) + 3;
          for (let i=0; i<copies; i++) {
            const clone = group.cloneNode(true);
            clone.removeAttribute('data-review-original');
            clone.setAttribute('data-review-clone',''); clone.setAttribute('aria-hidden','true'); clone.inert = true;
            clone.querySelectorAll('[data-shopify-editor-block], [id]').forEach(e => { e.removeAttribute('data-shopify-editor-block'); e.removeAttribute('id'); });
            track.append(clone);
          }
          row.setAttribute('data-enhanced','');
          const state = { row, track, distance, direction: row.dataset.direction, hovering:false, focusing:false, dragging:false };
          this.states.push(state);
          this.animate(state, 0);
          if (!row.dataset.bound) {
            row.dataset.bound = 'true';
            const options = { signal:this.abort.signal };
            row.addEventListener('pointerenter', event => { const s=this.state(row); if(s && event.pointerType==='mouse') {s.hovering=true;this.sync();} }, options);
            row.addEventListener('pointerleave', () => { const s=this.state(row);if(s){s.hovering=false;this.sync();} }, options);
            row.addEventListener('focusin', () => { const s=this.state(row);if(s){s.focusing=true;this.sync();} }, options);
            row.addEventListener('focusout', event => { const s=this.state(row);if(s && !row.contains(event.relatedTarget)){s.focusing=false;this.sync();} }, options);
            row.addEventListener('pointerdown', event => this.down(row,event), options);
            row.addEventListener('pointermove', event => this.move(row,event), options);
            row.addEventListener('pointerup', event => this.up(row,event), options);
            row.addEventListener('pointercancel', event => this.up(row,event), options);
            row.addEventListener('keydown', event => {
              const s=this.state(row); if(!s || !['ArrowLeft','ArrowRight'].includes(event.key))return;
              event.preventDefault(); this.setOffset(s, this.offset(s)+(event.key==='ArrowLeft'?1:-1)*Math.min(300,row.clientWidth*.8));
            }, options);
          }
        });
        this.sync();
      }
      state(row) { return this.states.find(s => s.row===row); }
      offset(state) { return new DOMMatrixReadOnly(getComputedStyle(state.track).transform).m41; }
      animate(state, offset) {
        state.animation?.cancel();
        const phase = ((-offset % state.distance) + state.distance) % state.distance;
        const start = state.direction==='right' ? -phase-state.distance : -phase;
        const end = start + (state.direction==='right'?state.distance:-state.distance);
        state.track.style.transform='';
        state.animation=state.track.animate([{transform:`translate3d(${start}px,0,0)`},{transform:`translate3d(${end}px,0,0)`}],{duration:state.distance/(Number(this.dataset.speed)||20)*1000,iterations:Infinity,easing:'linear'});
      }
      setOffset(state, offset) { this.animate(state,offset);this.sync(); }
      down(row,event) {
        const s=this.state(row); if(!s || (event.pointerType==='mouse' && event.button!==0))return;
        s.dragging=true;s.startX=event.clientX;s.startY=event.clientY;s.startOffset=this.offset(s);s.axis=null;
        s.animation.pause(); row.setAttribute('data-dragging','');
      }
      move(row,event) {
        const s=this.state(row);if(!s?.dragging)return;
        const dx=event.clientX-s.startX,dy=event.clientY-s.startY;
        if(!s.axis && Math.max(Math.abs(dx),Math.abs(dy))>5)s.axis=Math.abs(dx)>Math.abs(dy)?'x':'y';
        if(s.axis!=='x')return;
        if(!row.hasPointerCapture(event.pointerId))row.setPointerCapture(event.pointerId);
        s.animation.cancel();
        const phase=((-s.startOffset-dx)%s.distance+s.distance)%s.distance;
        s.track.style.transform=`translate3d(${-phase}px,0,0)`;
      }
      up(row,event) {
        const s=this.state(row);if(!s?.dragging)return;
        const offset=this.offset(s);s.dragging=false;row.removeAttribute('data-dragging');
        if(row.hasPointerCapture(event.pointerId))row.releasePointerCapture(event.pointerId);
        this.setOffset(s,offset);
      }
      sync() {
        this.states.forEach(s => {
          const paused=this.paused || this.inView===false || document.hidden || s.dragging || s.focusing || (this.dataset.pauseHover==='true' && s.hovering);
          if(paused)s.animation?.pause();else s.animation?.play();
        });
      }
    }
    customElements.define('lexi-review-marquee',LexiReviewMarquee);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["service-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lexi-service-carousel')) {
    customElements.define('lexi-service-carousel', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.track = this.querySelector('.service-carousel__track');
        this.slides = Array.from(this.querySelectorAll('.service-carousel__slide'));
        this.dots = Array.from(this.querySelectorAll('[data-slide]'));
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.index = 0;
        this.desktop = matchMedia('(min-width: 990px)');
        this.hovered = false;
        this.focused = false;
        this.dragging = false;
        this.visible = false;
        this.editorSelected = false;
        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.sync());
        }, { ...options, passive: true });
        this.addEventListener('click', event => {
          const button = event.target.closest('button');
          if (!button || !this.contains(button)) return;
          if (button.hasAttribute('data-slide')) this.go(Number(button.dataset.slide));
          if (button.hasAttribute('data-previous')) this.go(this.index - 1);
          if (button.hasAttribute('data-next')) this.go(this.index + 1);
          this.schedule();
        }, options);
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track) return;
          const rtl = getComputedStyle(this).direction === 'rtl';
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            this.go(this.index + ((event.key === 'ArrowRight') !== rtl ? 1 : -1));
          } else if (event.key === 'Home' || event.key === 'End') {
            event.preventDefault();
            this.go(event.key === 'Home' ? 0 : this.slides.length - 1);
          }
          this.schedule();
        }, options);
        this.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { this.hovered = true; this.schedule(); } }, options);
        this.addEventListener('pointerleave', () => { this.hovered = false; this.schedule(); }, options);
        this.track.addEventListener('pointerdown', () => { this.dragging = true; this.schedule(); }, options);
        window.addEventListener('pointerup', () => { this.dragging = false; this.schedule(); }, options);
        this.track.addEventListener('pointercancel', () => { this.dragging = false; this.schedule(); }, options);
        this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, options);
        this.addEventListener('focusout', event => { if (!this.contains(event.relatedTarget)) { this.focused = false; this.schedule(); } }, options);
        document.addEventListener('visibilitychange', () => this.schedule(), options);
        this.motion.addEventListener('change', () => this.schedule(), options);
        this.desktop.addEventListener('change', () => { this.go(this.index, true); this.sync(); this.schedule(); }, options);
        document.addEventListener('shopify:block:select', event => {
          const i = this.slides.findIndex(slide => slide.dataset.blockId === event.detail?.blockId);
          if (i < 0) return;
          this.editorSelected = true;
          this.go(i);
          this.schedule();
        }, options);
        document.addEventListener('shopify:block:deselect', () => { this.editorSelected = false; this.schedule(); }, options);
        this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.schedule(); }, { threshold: .25 });
        this.observer.observe(this);
        this.resizeObserver = new ResizeObserver(() => this.go(this.index, true));
        this.resizeObserver.observe(this.track);
        this.sync();
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        cancelAnimationFrame(this.frame);
        this.controller?.abort();
        this.observer?.disconnect();
        this.resizeObserver?.disconnect();
      }
      go(index, instant = false) {
        if (!this.slides.length) return;
        if (this.desktop.matches) { this.track.scrollTo({left: 0, behavior: 'instant'}); return; }
        const next = (index + this.slides.length) % this.slides.length;
        const target = this.slides[next].getBoundingClientRect();
        const track = this.track.getBoundingClientRect();
        this.track.scrollBy({left: target.left - track.left, behavior: instant || this.motion.matches ? 'instant' : 'smooth'});
      }
      sync() {
        if (!this.slides.length) return;
        this.track.tabIndex = this.desktop.matches ? -1 : 0;
        if (this.desktop.matches) {
          this.slides.forEach(slide => { slide.classList.add('is-active'); slide.inert = false; slide.removeAttribute('aria-hidden'); });
          return;
        }
        const bounds = this.track.getBoundingClientRect();
        const center = bounds.left + bounds.width / 2;
        let closest = Infinity;
        this.slides.forEach((slide, index) => {
          const rect = slide.getBoundingClientRect();
          const distance = Math.abs(rect.left + rect.width / 2 - center);
          if (distance < closest) { closest = distance; this.index = index; }
        });
        this.slides.forEach((slide, index) => {
          const active = index === this.index;
          slide.classList.toggle('is-active', active);
          slide.inert = !active;
          slide.setAttribute('aria-hidden', String(!active));
        });
        this.dots.forEach((dot, index) => index === this.index ? dot.setAttribute('aria-current', 'true') : dot.removeAttribute('aria-current'));
      }
      schedule() {
        clearTimeout(this.timer);
        if (this.dataset.autoplay !== 'true' || this.slides.length < 2 || this.motion.matches || this.desktop.matches || this.hovered || this.focused || this.dragging || !this.visible || this.editorSelected || document.hidden) return;
        this.timer = setTimeout(() => { this.go(this.index + 1); this.schedule(); }, Number(this.dataset.interval) || 5000);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
